import React from 'react';
import { config, getSocialLinks } from '../config/config';

const FacebookIcon = ({ className }) => (
  <svg
    viewBox='0 0 24 24'
    fill='currentColor'
    aria-hidden='true'
    className={className}
  >
    <path d='M24 12.073C24 5.404 18.627 0 12 0S0 5.404 0 12.073c0 6.019 4.388 11.009 10.125 11.927v-8.437H7.078V12.07h3.047V9.412c0-3.022 1.792-4.689 4.533-4.689 1.312 0 2.686.236 2.686.236v2.969h-1.514c-1.49 0-1.956.931-1.956 1.887v2.264h3.328l-.532 3.494h-2.796V24C19.612 23.082 24 18.092 24 12.073z' />
  </svg>
);

const InstagramIcon = ({ className }) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'
    className={className}
  >
    <rect x='2' y='2' width='20' height='20' rx='5' ry='5' />
    <path d='M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z' />
    <line x1='17.5' y1='6.5' x2='17.51' y2='6.5' />
  </svg>
);

const XIcon = ({ className }) => (
  <svg
    viewBox='0 0 24 24'
    fill='currentColor'
    aria-hidden='true'
    className={className}
  >
    <path d='M18.901 1.153h3.68l-8.037 9.184L24 22.846h-7.406L10.79 15.26l-6.64 7.586H.47l8.595-9.822L0 1.154h7.594l5.243 6.932 6.064-6.932zm-1.291 19.49h2.039L6.486 3.25H4.298L17.61 20.643z' />
  </svg>
);

const LinkedInIcon = ({ className }) => (
  <svg
    viewBox='0 0 24 24'
    fill='currentColor'
    aria-hidden='true'
    className={className}
  >
    <path d='M20.447 20.452h-3.554V14.87c0-1.331-.027-3.045-1.854-3.045-1.856 0-2.141 1.45-2.141 2.949v5.678H9.344V9h3.414v1.561h.049c.477-.9 1.637-1.849 3.37-1.849 3.601 0 4.267 2.37 4.267 5.455v6.285zM5.337 7.433a2.062 2.062 0 1 1 .001-4.124 2.062 2.062 0 0 1-.001 4.124zM7.119 20.452H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .775 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .775 23.2 0 22.222 0h.003z' />
  </svg>
);

const Footer = () => {
  const [isContactOpen, setIsContactOpen] = React.useState(false);

  // const openContact = () => setIsContactOpen(true);
  const closeContact = () => setIsContactOpen(false);

  return (
    <footer className='bg-teal-900 text-white border-t border-teal-800'>
      <div className='max-w-7xl mx-auto px-4 py-6 flex flex-col md:flex-row justify-between items-center gap-6'>
        {/* Left Section */}
        <div className='flex flex-col items-start w-full md:w-auto'>
          <h3 className='text-xl font-bold text-white'>
            {/* {config.company.name} app */}
            Vidura Infotech
          </h3>
          <p className='text-gray-200 text-sm mt-1'>
             An effort for a better future
          </p>
          <p className='text-gray-300 text-xs mt-3'>
            Copyright &copy; 2025 {config.company.name}. All Rights Reserved.
          </p>
          <p className='text-xs text-teal-300 mt-1'>
            Powered by{' '}
            <a
              href='https://staticval.com'
              target='_blank'
              rel='noopener noreferrer'
              className='underline hover:text-white'
            >
              Staticval
            </a>
          </p>
        </div>
        {/* Right Section */}
        <div className='flex flex-col items-start md:items-end w-full md:w-auto gap-2'>
          <div className='flex items-center gap-2 flex-wrap'>
            <span className='text-gray-200 text-sm mr-2'>Follow Us On:</span>
            <a
              href={getSocialLinks().facebook}
              target='_blank'
              rel='noopener noreferrer'
              aria-label='Facebook'
              className='rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-white'
            >
              <FacebookIcon className='w-6 h-6' />
            </a>
            <a
              href={getSocialLinks().instagram}
              target='_blank'
              rel='noopener noreferrer'
              aria-label='Instagram'
              className='rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-white'
            >
              <InstagramIcon className='w-6 h-6' />
            </a>
            <a
              href={getSocialLinks().twitter}
              target='_blank'
              rel='noopener noreferrer'
              aria-label='X'
              className='rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-white'
            >
              <XIcon className='w-6 h-6' />
            </a>
            <a
              href={getSocialLinks().linkedin}
              target='_blank'
              rel='noopener noreferrer'
              aria-label='LinkedIn'
              className='rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-white'
            >
              <LinkedInIcon className='w-6 h-6' />
            </a>
          </div>
          <div className='flex flex-wrap gap-1 text-xs text-teal-200 mt-2'>
            <button
              onClick={() => window.open('/privacy-policy', '_blank')}
              className='cursor-pointer hover:underline bg-transparent border-none text-xs text-teal-200 hover:text-white p-0'
            >
              Privacy
            </button>
            <span>|</span>
            <button
              onClick={() => window.open('/terms-of-service', '_blank')}
              className='cursor-pointer hover:underline bg-transparent border-none text-xs text-teal-200 hover:text-white p-0'
            >
              Terms
            </button>
            <span>|</span>
            <button
              onClick={() => window.open('/Trinethra-terms', '_blank')}
              className='cursor-pointer hover:underline bg-transparent border-none text-xs text-teal-200 hover:text-white p-0'
            >
              Trinethra Terms
            </button>
            <span>|</span>
            <button
              onClick={() => window.open('/refund-policy', '_blank')}
              className='cursor-pointer hover:underline bg-transparent border-none text-xs text-teal-200 hover:text-white p-0'
            >
              Refund Policy
            </button>
            <span>|</span>
            <button
              onClick={() => window.open('/about-us', '_blank')}
              className='cursor-pointer hover:underline bg-transparent border-none text-xs text-teal-200 hover:text-white p-0'
            >
              About Us
            </button>
            <span>|</span>
            <button
              onClick={() => window.open('/data-deletion-policy', '_blank')}
              className='cursor-pointer hover:underline bg-transparent border-none text-xs text-teal-200 hover:text-white p-0'
            >
              Data Deletion Policy
            </button>
            <span>|</span>
            <button
              onClick={() => window.open('/contact', '_blank')}
              className='cursor-pointer hover:underline bg-transparent border-none text-xs text-teal-200 hover:text-white p-0'
            >
              Contact
            </button>
          </div>
        </div>
        {/* Contact Modal */}
        {isContactOpen && (
          <div className='fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4'>
            <div className='bg-white rounded-lg shadow-xl max-w-md w-full p-6 relative'>
              <button
                onClick={closeContact}
                className='absolute top-4 right-4 text-gray-500 hover:text-gray-700'
                aria-label='Close'
              >
                <svg
                  className='w-6 h-6'
                  fill='none'
                  stroke='currentColor'
                  viewBox='0 0 24 24'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth={2}
                    d='M6 18L18 6M6 6l12 12'
                  />
                </svg>
              </button>
              <h2 className='text-2xl font-bold text-teal-900 mb-4'>
                Contact Us
              </h2>
              <div className='space-y-4 text-gray-700'>
                <div>
                  <h3 className='font-semibold text-teal-800'>Email</h3>
                  <a
                    href={`mailto:${config.company.email}`}
                    className='text-teal-600 hover:underline'
                  >
                    {config.company.email}
                  </a>
                </div>
                {/* <div>
                  <h3 className="font-semibold text-teal-800">Phone</h3>
                  <a
                    href={`tel:${config.company.phone.replace(/\D/g, "")}`}
                    className="text-teal-600 hover:underline"
                  >
                    {config.company.phone}
                  </a>
                </div>
                <div>
                  <h3 className="font-semibold text-teal-800">Address</h3>
                  <p className="text-sm">
                    {config.address.street}
                    <br />
                    {config.address.city}, {config.address.state}{" "}
                    {config.address.zip}
                  </p>
                </div>
                <div>
                  <h3 className="font-semibold text-teal-800">
                    Business Hours
                  </h3>
                  <p className="text-sm">
                    Weekdays: {config.businessHours.weekday}
                    <br />
                    Weekends: {config.businessHours.weekend}
                  </p>
                </div> */}
              </div>
            </div>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
